import {PencilIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {type RefObject, useCallback, useRef} from 'react'

import type {PanelArtifact} from './ArtifactPanelContent'
import type {EditableArtifact} from './create-artifact-dialog-types'

type ArtifactEditButtonProps = {
  artifact: PanelArtifact | null
  onEdit: (artifact: EditableArtifact, returnFocusRef: RefObject<HTMLElement | null>) => void
}

export function ArtifactEditButton({artifact, onEdit}: ArtifactEditButtonProps) {
  const buttonRef = useRef<HTMLButtonElement>(null)
  const handleClick = useCallback(() => {
    if (!artifact || artifact.number === undefined) return
    onEdit(
      {
        number: artifact.number,
        type: artifact.type,
        name: artifact.name,
        body: artifact.body,
      },
      buttonRef,
    )
  }, [artifact, onEdit])

  if (!artifact || artifact.number === undefined) return null

  return (
    <IconButton
      ref={buttonRef}
      icon={PencilIcon}
      variant="invisible"
      aria-label="Edit artifact"
      onClick={handleClick}
    />
  )
}
